import { render, staticRenderFns } from "./WorkFlowFloatingTaskBar.vue?vue&type=template&id=2327bb3f&scoped=true"
import script from "./WorkFlowFloatingTaskBar.vue?vue&type=script&lang=js"
export * from "./WorkFlowFloatingTaskBar.vue?vue&type=script&lang=js"
import style0 from "./WorkFlowFloatingTaskBar.vue?vue&type=style&index=0&id=2327bb3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2327bb3f",
  null
  
)

export default component.exports